import { BudgetData } from "@src/app/types/Page";

import SingaporeBudget2024 from "./2024/SingaporeBudget2024";
import { isBudget2024Data } from "./helpers";

export const SingaporeBudgetLayoutFactory = (data: BudgetData) => {
  if (isBudget2024Data(data)) {
    return SingaporeBudget2024;
  }

  // switch (year) {
  //   case 2024:
  //     return SingaporeBudget2024;
  // }
};
